export const getEntity = (entities, entityType, id) => {
	const { byId, allIds } = entities[entityType];
	if (byId && allIds && allIds.length > 0 && id) {
		return byId[id];
	}
	return null;
};

export const getEntityArray = (entities, entityType, idsArray = null) => {
	let entitiesArray = null;
	const { byId, allIds } = entities[entityType];
	if (!idsArray) {
		if (allIds && allIds.length > 0) {
			entitiesArray = allIds.map((id, i) => byId[id]);
		}
	} else if (idsArray && idsArray.length > 0) {
		entitiesArray = [];
		for (const id of idsArray) {
			const entity = byId[id];
			if (entity) {
				entitiesArray.push(entity);
			}
		}
	}
	return entitiesArray;
};

export const getEntityObject = (entities, entityType, idsArray = null) => {
	let entitiesObj = null;

	if (!idsArray) {
		entities[entityType];
	} else {
		const { byId, allIds } = entities[entityType];
		if (idsArray && idsArray.length > 0) {
			entitiesObj = {
				byId: {},
				allIds: []
			};
			for (const id of idsArray) {
				const entity = byId[id];
				if (entity) {
					entitiesObj.byId[id] = byId[id];
					entitiesObj.allIds.push(id);
				}
			}
		}
	}
	return entitiesObj;
};

export const getFilteredEntityArray = (
	entities,
	entityType,
	filterFunction
) => {
	let result = null;
	const allEntityArray = getEntityArray(entities, entityType);
	if (allEntityArray && allEntityArray.length > 0) {
		result = allEntityArray.filter(filterFunction);
	}
	return result;
};

export const getFilteredEntityKeysArray = (
	entities,
	entityType,
	filterFunction,
	keyName
) => {
	let result = null;
	const { byId, allIds } = entities[entityType];
	if (allIds && allIds.length > 0) {
		result = [];
		for (const id of allIds) {
			if (filterFunction(byId[id])) {
				result.push(id);
			}
		}
	}

	return result;
};
